import * as React from "react";

import { Input } from "@neworbit/simpleui-input";

import { OHCaseModel } from "../models";

interface IProps {
    ohCases: OHCaseModel[];
    value: string;
    onChange: (ohCaseId: string) => void;
}

const OhCaseDropdown: React.FunctionComponent<IProps> = (props: IProps) => {
    return (
        <Input.Dropdown
            label="Linked OH Case"
            onChange={props.onChange}
            options={[{ text: "None", value: null }].concat(props.ohCases.map(oh => ({ value: oh.id, text: `${oh.caseId} - ${oh.caseType}` })))}
            value={props.value}
        />
    );
};

export default OhCaseDropdown;
